<template>
    <b-modal
        id="modalEditVideo"
        ref="videoEditModal"
        title="映像情報を編集"
        :size="noShare ?'md':'lg'"
        cancel-title="キャンセル"
        ok-title="保存"
        @ok="submit"
        @shown="modalOpen"
    >
        <b-form
            ref="videoEditForm"
            @submit.prevent
        >
            <div class="row">
                <div :class="noShare ?'col-12':'col-12 col-md-5'">
                    <b-form-group
                        label="タイトル"
                        label-for="upload-title"
                        description="後で検索できるようなタイトルしてください"
                    >
                        <b-form-input
                            id="upload-title"
                            v-model="form.name"
                            type="text"
                            placeholder="映像のタイトルを入力してください"
                            required
                        />
                    </b-form-group>
                    <b-form-group
                        label="日付"
                        label-for="upload-date"
                        description="撮影日"
                    >
                        <datepicker
                            v-model="form.shot_date"
                            :disabled-dates="datePicker.disabledDates"
                            bootstrap-styling
                            calendar-button
                            :calendar-button-icon="datePicker.icon"
                            :language="datePicker.language"
                            :format="datePicker.format"
                            required
                        />
                    </b-form-group>
                    <b-form-group
                        label="詳細"
                        label-for="upload-description"
                        description="映像に対する詳細、メモなど"
                    >
                        <b-form-textarea
                            id="upload-description"
                            v-model="form.description"
                            type="text"
                            placeholder=""
                            rows="2"
                            max-rows="3"
                        />
                    </b-form-group>
                </div>
                <div
                    v-if="!noShare"
                    class="col-12 col-md-7"
                >
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col">
                                    <b-form-group :label="'閲覧権限'+aclSelected">
                                        <div
                                            style="max-height: 330px; overflow-y: auto;"
                                            class="px-1"
                                        >
                                            <b-form-checkbox-group
                                                id="teams-editor"
                                                v-model="acls"
                                                name="teams"
                                                value-field="group_id"
                                                text-field="name"
                                                stacked
                                                :options="groups"
                                            />
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-btn
                                        size="sm"
                                        block
                                        variant="outline-success"
                                        @click="checkAll"
                                    >
                                        すべてをチェック
                                    </b-btn>
                                </div>
                                <div class="col">
                                    <b-btn
                                        size="sm"
                                        block
                                        variant="outline-danger"
                                        @click="unCheckAll"
                                    >
                                        すべてを外す
                                    </b-btn>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col">
                                    <b-form-group :label="'DL権限'+aclDLSelected">
                                        <div
                                            style="max-height: 330px; overflow-y: auto;"
                                            class="px-1"
                                        >
                                            <b-form-checkbox-group
                                                id="teams-dl-editor"
                                                v-model="acls_dl"
                                                name="teams_dl"
                                                value-field="group_id"
                                                text-field="name"
                                                stacked
                                                :options="groups"
                                            />
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-btn
                                        size="sm"
                                        block
                                        variant="outline-success"
                                        @click="checkAllDL"
                                    >
                                        すべてをチェック
                                    </b-btn>
                                </div>
                                <div class="col">
                                    <b-btn
                                        size="sm"
                                        block
                                        variant="outline-danger"
                                        @click="unCheckAllDL"
                                    >
                                        すべてを外す
                                    </b-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-form>
    </b-modal>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { datePicker } from '@/variables.js'
import { mapState } from 'pinia'
import { store } from '@/store.js'

export default {
    name: 'VideoEditModal',
    components: {
        Datepicker
    },
    data () {
        return {
            video_id: 0,
            form: {},
            acls: [],
            acls_dl: [],
            datePicker
        }
    },
    computed: {
        ...mapState(store, ['user', 'groups', 'noShare']),
        team_id () {
            return this.user.group.group_id
        },
        aclSelected () {
            return this.acls.length - 1 > 0 ? '（' + (this.acls.length - 1) + '件選択中）' : ''
        },
        aclDLSelected () {
            return this.acls_dl.length - 1 > 0 ? '（' + (this.acls_dl.length - 1) + '件選択中）' : ''
        }
    },
    watch: {
        acls_dl: {
            handler (val) {
                val.forEach(v => {
                    if (!this.acls.includes(v)) {
                        this.acls.push(v)
                    }
                })
            },
            deep: true
        }
    },
    mounted () {
        this.$root.$on('openVideoEditModal', (videoId) => {
            this.$http.get('video/' + videoId).then((r) => {
                if (r) {
                    this.form = r.data.video
                    this.acls = r.data.acl.filter(value => value.streaming).map(value => value.group_id)
                    this.acls_dl = r.data.acl.filter(value => value.download).map(value => value.group_id)
                    this.video_id = videoId
                    this.$refs.videoEditModal.show()
                }
            }).catch((error) => {
                if (error.response) {
                    switch (error.response.status) {
                    case 401:
                        // this.$loggedIn = false;
                        break
                    case 403:
                        this.$snotify.error('編集する権限がありません')
                        break
                    default:
                        if (error.response.data && error.response.data.error) {
                            this.$snotify.error(error.response.data.error)
                        } else {
                            this.$snotify.error('サーバーエラー')
                        }
                        break
                    }
                } else {
                    this.$ab?.notify(error)
                }
            })
        })
    },
    methods: {
        unCheckAll () {
            this.acls = [this.team_id]
        },
        checkAll () {
            const a = [this.team_id]
            for (let i = 0; i < this.groups.length; i++) {
                a.push(this.groups[i].group_id)
            }
            this.acls = a
        },
        unCheckAllDL () {
            this.acls_dl = [this.team_id]
        },
        checkAllDL () {
            const a = [this.team_id]
            for (let i = 0; i < this.groups.length; i++) {
                a.push(this.groups[i].group_id)
            }
            this.acls_dl = a
        },
        modalOpen () {
            //
        },
        submit (e) {
            e.preventDefault()
            if (!this.form.name || !this.form.description || !this.form.shot_date) {
                return
            }
            const $this = this
            const data = {
                name: this.form.name,
                description: this.form.description ? this.form.description : '',
                shot_date: this.$moment(this.form.shot_date).format('YYYY-MM-DD'),
                acl: this.acls,
                acl_dl: this.acls_dl
            }
            console.log(data)
            $this.$root.$emit('loading', true)
            this.$http.post('video/' + this.form.video_id, data).then((response) => {
                if (response) {
                    this.$refs.videoEditModal.hide()
                    this.$root.$emit('updateTable')
                    /* eslint-disable no-undef */
                    this.$log('edit', { event_label: data.name })
                }
            }).catch((error) => {
                if (error.response) {
                    switch (error.response.status) {
                    case 401:
                        break
                    case 403:
                        this.$snotify.error('編集する権限がありません')
                        break
                    default:
                        if (error.response.data && error.response.data.error) {
                            $this.$snotify.error(error.response.data.error)
                        } else {
                            $this.$snotify.error('サーバーエラー')
                        }
                        break
                    }
                } else if (error.request) {
                    console.log(error.request)
                } else {
                    this.$snotify.error(error.message)
                    console.log(error.config)
                    if (this.$ab) {
                        this.$ab.notify(error)
                    }
                }
            }).finally(() => {
                this.$root.$emit('loading', false)
            })
        }
    }
}
</script>
